export default __webpack_public_path__ + "static/media/bag.4f0696c1.png";